"use client";

import { motion } from "motion/react";

const revealVariants = {
  wipe: {
    hidden: { clipPath: "inset(0 100% 0 0)" },
    visible: { clipPath: "inset(0 0% 0 0)" },
  },
  rise: {
    hidden: { clipPath: "inset(100% 0 0 0)", y: 28 },
    visible: { clipPath: "inset(0% 0 0 0)", y: 0 },
  },
  zoom: {
    hidden: { clipPath: "inset(50% 50% 50% 50%)", scale: 1.06 },
    visible: { clipPath: "inset(0% 0% 0% 0%)", scale: 1 },
  },
};

export function ImageReveal({
  children,
  className,
  delay = 0,
  mode,
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  mode: keyof typeof revealVariants;
}) {
  return (
    <motion.div
      animate="visible"
      className={className}
      initial="hidden"
      transition={{ duration: 0.4, delay, ease: [0.22, 1, 0.36, 1] }}
      variants={revealVariants[mode]}
    >
      {children}
    </motion.div>
  );
}
